export default "__VITE_PUBLIC_ASSET__0b53f398__"